export const categorySliderQuery = /* GraphQL */ `
    query CategorySlider($category_id: Int) {
        CategorySlider(category_id: $category_id) {
            categoryItems {
                category_id
                name
                url
                imageUrl
                position
                current
                hide_name_in_slider
            }
        }
    }
`
